import { useEffect } from 'react';

// a useEffect with an empty dependency list, so it only fires once
export const useInitialize = (callback: () => void) => {
    useEffect(() => {
        callback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
